import { useSyncExternalStore } from "react";
import { defaultTheme } from "../shared/constants";

export const useMediaQuery = (query: string): boolean =>
  useSyncExternalStore(
    (onStoreChange) => {
      const mql = window.matchMedia(query);
      mql.addEventListener("change", onStoreChange);
      return () => mql.removeEventListener("change", onStoreChange);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );

export const useMaxWidthBreakpoint = (
  breakpoint: keyof typeof defaultTheme.BREAKPOINTS,
): boolean =>
  useMediaQuery(`(max-width: ${defaultTheme.BREAKPOINTS[breakpoint]})`);

export const useIsMobile = () => useMaxWidthBreakpoint("MD");
